import type { EnvironmentConfig } from '../types';

// Récupérer l'URL de l'API depuis les variables d'environnement ou utiliser les valeurs par défaut
const getApiUrl = (): string => {
  // Priorité à VITE_API_URL depuis le .env
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL;
  }
  
  // Sinon, utiliser les valeurs par défaut selon l'environnement
  const environment = import.meta.env.MODE || 'development';
  if (environment === 'production') {
    return 'https://api.postdev.fr';
  }
  if (environment === 'preproduction') {
    return 'https://preprod-api.postdev.fr';
  }
  return 'http://localhost:4000';
};

const configs: Record<string, EnvironmentConfig> = {
  development: {
    apiUrl: 'http://localhost:4000',
    environment: 'development',
    analytics: {
      enabled: false,
      id: 'dev-analytics-id'
    }
  },
  
  preproduction: {
    apiUrl: 'https://preprod-api.postdev.fr', // Alias pour preprod
    apiUrlWithWWW: 'https://www.preprod-api.postdev.fr',
    environment: 'preproduction',
    sentryDsn: 'https://your-sentry-dsn-preprod',
    analytics: {
      enabled: true,
      id: 'preprod-analytics-id'
    }
  },
  production: {
    apiUrl: 'https://api.postdev.fr', // Valeur par défaut, sera surchargée par VITE_API_URL si défini
    apiUrlWithWWW: 'https://www.api.postdev.fr', // Ajout de la variante avec www
    environment: 'production',
    sentryDsn: 'https://your-sentry-dsn-production',
    analytics: {
      enabled: true,
      id: 'production-analytics-id'
    }
  }
};

const environment = import.meta.env.MODE || 'development';
export const config = {
  ...configs[environment],
  // Surcharger apiUrl avec la valeur de VITE_API_URL si elle existe
  apiUrl: getApiUrl()
};

/**
 * Obtenir l'URL d'une image selon l'environnement
 * En développement, utilise le proxy Vite
 * En production, utilise l'URL complète de l'API
 */
export function getImageUrl(path: string): string {
  if (import.meta.env.DEV) {
    // En développement, utiliser le proxy Vite
    return `/${path}`;
  }
  // En production, utiliser l'URL complète de l'API
  return `${config.apiUrl}/${path}`;
}

/**
 * Obtenir l'URL d'une image de blog selon l'environnement
 */
export function getBlogImageUrl(filename: string): string {
  return getImageUrl(`uploads/blog/${filename}`);
}